import { FormControl, InputBase, MenuItem, Select } from "@mui/material";
import { useState } from "react";

export const PlaceholderCategorySelect = ({
  category,
  placeholders,
  onCopy,
}: {
  category: string;
  placeholders: { placeholderName: string }[];
  onCopy: () => void;
}) => {
  const [search, setSearch] = useState("");
  const filtered = placeholders.filter((el) =>
    el.placeholderName.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <FormControl sx={{ minWidth: 150 }}>
      <Select
        displayEmpty
        renderValue={() => category.replace(/_/g, " ").toUpperCase()}
        onChange={(e) => {
          navigator.clipboard.writeText(`{{${e.target.value}}}`);
          onCopy();
        }}
        sx={{ height: 40 }}
        MenuProps={{ autoFocus: false, PaperProps: { sx: { maxHeight: 300 } } }}
        onClose={() => setSearch("")}
      >
        <MenuItem disableRipple onKeyDown={(e) => e.stopPropagation()}>
          <InputBase
            autoFocus
            placeholder="Cerca..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            sx={{ px: 1, width: "100%" }}
          />
        </MenuItem>
        {filtered.map((el) => (
          <MenuItem key={el.placeholderName} value={el.placeholderName}>
            {el.placeholderName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
